type FormattedLogOptions = {
	area: string;
	message: string;
	customStylings?: string | CSSStyleDeclaration;
};

export const FormattedLog = {
	log: (args: FormattedLogOptions) => {
		console.log(`%c[${args.area}]`, `color:lime;background:black;${args.customStylings || ''}`, ` ${args.message}`);
	},
};
